import { Button } from "@/components/ui/Button";
import { useCurrency } from "@/contexts/CurrencyContext";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import Image from "next/image";

export default function RouteCard({ 
  item, 
  translationNamespace = "common" 
}) {
  const {
    date,
    logo,
    fromCity,
    fromStation,
    fromTime,
    duration,
    toCity,
    toStation,
    toTime,
    price,
  } = item;

  const { currency } = useCurrency();
  const t = useTranslationDetector(translationNamespace);

  return (
    <div className="flex w-full flex-col gap-[16px] rounded-xl border border-gray-200 bg-white px-[24px] py-[20px] shadow-sm">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Image src={logo} width={137} height={40} alt="Company logo" />
        </div>
        <span className="text-sm leading-[19px]">{date}</span>
      </div>

      {/* Route Info */}
      <div>
        <div className="flex w-full flex-col gap-1">
          <div className="relative grid w-full grid-cols-[1fr_auto_1fr] items-center gap-2 overflow-hidden">
            <div className="text-foreground-primary z-10 justify-self-start bg-white text-lg font-semibold">
              <p className="overflow-hidden text-lg leading-[26px] font-semibold text-ellipsis sm:w-20 lg:w-44">
                {fromCity}
              </p>
            </div>
          
          <span className="relative mx-2 flex h-[26px] items-center rounded-sm bg-gray-100 px-[8px] text-center text-xs leading-[26px] whitespace-nowrap before:border-border-card before:absolute before:top-1/2 before:right-full before:mr-2 before:w-[50px] before:-translate-y-1/2 before:border-t before:content-[''] after:border-border-card after:absolute after:top-1/2 after:left-full after:ml-2 after:w-[50px] after:-translate-y-1/2 after:border-t after:content-['']">
            {duration}
          </span>
          
            <div className="text-foreground-primary z-10 justify-self-end bg-white text-lg font-semibold">
              <p className="overflow-hidden text-right text-lg font-semibold text-ellipsis sm:w-20 lg:w-44">
                {toCity}
              </p>
            </div>
          </div>
        </div>

        {/* Stations and Times */}
        <div className="flex items-center justify-between">
          <div>
            <p className="text-foreground-muted">{fromStation}</p>
            <p className="mt-1 font-medium">{fromTime}</p>
          </div>
          <div className="text-right">
            <p className="text-foreground-muted">{toStation}</p>
            <p className="mt-1 font-medium">{toTime}</p>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="w-full border-t border-border-card" />

      {/* Footer */}
      <div className="flex items-center justify-between">
        <p className="text-lg font-medium">
          {price} {currency}
        </p>
        <Button className="flex h-[36px] flex-row items-center px-4 lg:px-4">
          <span className="text-sm">{t("buyNow")}</span>
        </Button>
      </div>
    </div>
  );
}
